<div class="block-standard">
  <div class="spen-mod-heading lv-2 header-title">
    <h2 class="heading-text">
      @if (option['inAlbum']) {
        <i class="fa fa-file-text-o"></i>
      }
      {{ document?.title }}
    </h2>
  </div>
  @if (isMultipleWork) {
    @for (answer of document.document_answers; track answer.id; let i = $index) {
      <div>
        <div class="question-answer">
          <div class="question-number">
            項目{{ i + 1 }}
            @if (isCompassAnswer) {
              <span class="required">必須</span>
            }
          </div>
          <div class="block-element">
            <p class="question preserve-line-break" appConvertLink>
              {{ answer.work_question.content.description || answer.work_question.content }}
            </p>
            @if (answer.work_question.image) {
              <img src="{{ answer.work_question.image.thumbnail }}" />
            }
            <p class="answer-title">回答</p>
            <p class="preserve-line-break" appConvertLink>{{ answer.content }}</p>
            <div class="answer-images">
              <app-files-view-student [files]="answer.upload_files"></app-files-view-student>
            </div>
          </div>
        </div>
      </div>
    }
  } @else {
    <div class="block-element">
      <p class="preserve-line-break" appConvertLink>{{ document?.content }}</p>
    </div>
    <div class="thumb">
      <app-files-view-student [files]="document?.upload_files"></app-files-view-student>
    </div>
  }
  @if (!!categoryName) {
    <div class="row category-detail">
      <div class="col-md-4 col-sm-4 col-four-1440 col-xs-6">
        <div class="category-text">
          {{ categoryName }}
        </div>
      </div>
    </div>
  }
  @if (marks?.length > 0) {
    <div class="marks">
      @for (mark of marks; track mark.id) {
        <div class="row">
          <img [src]="mark.icon" />
          <p>{{ mark.name }}</p>
        </div>
      }
    </div>
  }
</div>
